import { saveProgress } from 'helpers/player';
import { pingDiscord } from 'helpers/server_connection';

export function saveStoryProgress(scene, id, track = true) {
  saveProgress('cl-storyProgress', id);
  const gameMenu = scene && scene.scene.get('GameMenuScene');
  if (gameMenu) {
    gameMenu.showObjectiveUpdated();
  }
}

export const maybeStoreBattleResults = (
  levelIndex,
  score,
  grade,
  levelNameOverride = ''
) => {
  const playerName = window.localStorage.getItem('chesslike-user');
  const highScores =
    JSON.parse(window.localStorage.getItem('chesslike-highscores')) || {};
  const levelName = levelNameOverride || levelIndex;
  let bestChanged = false;
  if (highScores[levelIndex]) {
    if (highScores[levelIndex].score < score) {
      highScores[levelIndex] = { score, grade };
      bestChanged = true;
      pingDiscord(
        `**${playerName}** just improved their score in Freeplay Mode on level: ${levelName ||
          levelIndex}!
        Score: ${score}
        Grade: ${grade}`
      );
    }
  } else {
    highScores[levelIndex] = { score, grade };
    bestChanged = true;
  }
  window.localStorage.setItem(
    'chesslike-highscores',
    JSON.stringify(highScores)
  );
  return { bestChanged };
};
